"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SearchTransactionDto = void 0;
const cursor_pagination_1 = require("../cursor-pagination");
class SearchTransactionDto extends cursor_pagination_1.CursorPaginationOptions {
    /**
     * @deprecated
     */
    advertismentId;
    campaignId;
    displayId;
    flatten;
    from;
    gateway;
    /**
     * @deprecated
     */
    gifId;
    mediaId;
    /**
     * @deprecated
     */
    overlayId;
    paymentGatewayTxId;
    reactionId;
    reason;
    ref;
    status;
    to;
    transactionId;
    type;
    userId;
    walletId;
    walletOwnerId;
    withAmount;
}
exports.SearchTransactionDto = SearchTransactionDto;
